import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/styles';
import React from 'react';
import PropTypes from 'prop-types';

//MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

//BIKENTA
import Row from '../../Row';

import { useTranslation } from 'react-i18next';

const MenuHeader = ({cuartel, ua, uo}) => {

  const {t} = useTranslation();
  const theme = useTheme();
  const widescreen = useMediaQuery(theme.breakpoints.up('lg'), {noSsr: true});

  //STYLES
  const interventionZoneTitle = {
    color: 'primary.contrastText',
    fontWeight: '900',
    mr: 0.5
  };

  return <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" flexWrap="wrap" sx={{bgcolor: 'primary.light', borderRadius: 1, mb: 0}}>
    <Box display="flex" flexDirection="row" m={1}>
      <Row sx={{mr: 1}}>
        <Typography sx={interventionZoneTitle} variant={widescreen ? 'h2' : 'subtitle2'}>{t('U.Actuación')}</Typography>
        <Typography sx={interventionZoneTitle}>{ua}</Typography>
      </Row>
      <Row sx={{mr: 1}}>
        <Typography sx={interventionZoneTitle} variant={widescreen ? 'h2' : 'subtitle2'}>{t('UO')}</Typography>
        <Typography sx={interventionZoneTitle}>{uo}</Typography>
      </Row>
      <Row sx={{mr: 1}}>
        <Typography sx={interventionZoneTitle} variant={widescreen ? 'h2' : 'subtitle2'}>{t('Cuartel')}</Typography>
        <Typography sx={interventionZoneTitle}>{cuartel}</Typography>
      </Row>
    </Box>
  </Box>;
};

MenuHeader.propTypes = {
  cuartel: PropTypes.string,
  uo: PropTypes.string,
  ua: PropTypes.string,
  onExportClick: PropTypes.func.isRequired,
  onNotificationClick: PropTypes.func.isRequired,
  onShareClick: PropTypes.func.isRequired,
};

export default MenuHeader;